import React, { useState, useEffect, Fragment } from "react";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import Layout from "components/sales/layout/layout";
import FormSection from "components/sales/formSection/formSectionNew";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from 'react-toastify'; 

const SalaryPromotion = ({ 
    match, 
    history, 
    updateValetListData,
    getValetListData,
    valetListData = []
}) => {
  const inputs = {
    current_base_salary: "",
    new_base_salary: "",
    reconfirm_base_salary: "",
    note_check: false,
  };

  const [formData, setFormData] = useState(inputs);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [offDay, setOffDay] = useState([]);
  const [updateDate, setUpdateDate] = useState('');

  useEffect(() => {
      const today = new Date();
      let day = today.getDate();
      let month = today.getMonth() + 1; // JavaScript months are 0-11
      let year = today.getFullYear();

      if (day > 25) {
          month += 1;
          if (month > 12) {
              month = 1;
              year += 1;
          }
      }

      const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
      ];

      const monthName = monthNames[month - 1];
      setUpdateDate(`${monthName} ${year}`);
  }, []);

  useEffect(() => {
    (async () => {
        setIsLoading(true)
        await getValetListData({user_id: match?.params?.user_id}, 1)
        setIsLoading(false)
    })();
}, [])


  const handleSubmit = async (e) => {
    e.preventDefault();
    const offDays = [];

    offDay.map((val, index) => {
        offDays[index] = val.id;
    });

    if (formData?.new_base_salary !== formData?.reconfirm_base_salary) {
        toast.error("New base salary and re-confirm base salary should be the same.");
        return;
    }
    if (!formData?.note_check) {
      toast.error("Please check the note.");
      return;
    }

    const payload = {
        action: 'update_salary',
        role: formData?.role,
        user_id: formData?.user_id,
        new_salary: formData?.new_base_salary,
        token_role_id: window.localStorage.getItem("fusion-role")
    };

    setIsLoading(true);
    try {
        const res = await updateValetListData(payload);
        console.log("RES:", res);

        if (res?.message === "Success") { 
            setIsModal(true);
        }
    } catch (error) {
        console.error("Error:", error);
    } finally {
        setIsLoading(false);
    }
  };


  const handleModalHide = () => {
    setIsModal(false);
  };

  useEffect(() => {
    if(valetListData?.resultSets && valetListData?.resultSets[0] && Object.keys(valetListData?.resultSets[0]).length > 0){
        formData['first_name'] = valetListData?.resultSets[0]['first_name'];
        formData['last_name'] = valetListData?.resultSets[0]['last_name'];
        formData['phone_number'] = valetListData?.resultSets[0]['phone_number'];
        formData['salary'] = valetListData?.resultSets[0]['salary'];
        formData['role'] = valetListData?.resultSets[0]['role'];
        formData['user_id'] = valetListData?.resultSets[0]['user_id'];
        setFormData(formData)
    }
}, [valetListData])

  return (
    <Layout title={"Valet Salary"} isGoback isLoading={isLoading}>
      <FormSection title={"Update Base Salary"}>
        <div className="row">
            <div className="col-md-6">
                <ConstantInput
                    value={formData.first_name}
                    label={"First Name"}
                    type="text"
                    disabled={true}
                />
            </div>
            <div className="col-md-6">
                <ConstantInput
                    value={formData.last_name}
                    label={"Last Name"}
                    type="text"
                    disabled={true}
                />
            </div>
            <div className="col-md-6">
                <ConstantInput
                    value={formData.phone_number}
                    label={"Mobile Number"}
                    type="text"
                    disabled={true}
                />
            </div>
            <div className="col-md-6">
                <ConstantInput
                    value={formData.salary ?? 0}
                    label={"Current Base Salary"}
                    type="number"
                    disabled={true}
                />
            </div>
            <div className="col-md-6">
                <ConstantInput
                    label={"New Base Salary"}
                    type="number"
                    errorMsg={"New base salary is required"}
                    required
                    handleChange={(value) =>
                    setFormData({ ...formData, new_base_salary: value })
                    }
                    isStarRequired={true}
                    fullWidth
                    value={formData?.half_day_min_hour}
                />
            </div>
            <div className="col-md-6">
            <ConstantInput
                label={"Re-confirm Base Salary"}
                errorMsg={"Re-confirm base salary is required"}
                type="number"
                required
                handleChange={(value) =>
                setFormData({ ...formData, reconfirm_base_salary: value })
                }
                isStarRequired={true}
                fullWidth
                value={formData?.full_day_min_hour}
            />
            </div>
        </div>
        <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="col-md-6" style={{ display: 'flex', alignItems: 'center' }}>
                <input 
                    type="checkbox" 
                    onChange={(val) => setFormData({ ...formData, note_check: val.target.checked })}
                    style={{ position: 'relative', width: '2rem', top: '-5px'}}
                />  
                <label style={{ marginLeft: '0.5rem', color: 'red' }}>
                    *Please note: Did salary will be updated for {updateDate}
                </label>
            </div>
        </div>

        <div className="col-md-4 mt-5">
        <button className="btn btn-sm btn-success" onClick={handleSubmit} disabled={!formData?.note_check}>
            Submit
        </button>
        </div>
      </FormSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{'Valet details updated successfully'}</h5>
          <Link
            to={`${baseUrl}/all-supervisor-listing`}
            className="btn btn-primary mb-4"
          >
            Valet List <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default SalaryPromotion;
